import { Component, OnInit } from '@angular/core';
import { UserService } from "../services/user/user.service";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { ActivatedRoute, ParamMap } from '@angular/router';
@Component({
  selector: 'app-facture',
  templateUrl: './facture.component.html',
  styleUrls: ['./facture.component.css']
})
export class FactureComponent implements OnInit {

  constructor(public userService:UserService,private route: ActivatedRoute) { }
   user
   factureItems
   total=0
  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      var id = params.get('id')
      this.userService.getProfile().subscribe(res=>{
        this.user = res['profile']
        this.userService.getFacturesDetails(id).subscribe(res=>{
          this.factureItems = res['data']
          this.factureItems.forEach(item => {
            this.total += (item.NETPRI*item.QTY)+(item.NETPRI*item.QTY)*0.2
          });
        })
      })

    })

  }
  public openPDF(): void {
    let DATA: any = document.getElementById('facture');
    html2canvas(DATA).then((canvas) => {
      let fileWidth = 208;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF('p', 'mm', 'a4');
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save('facture'+this.user.BPRNUM+'.pdf');
    });
  }

}
